import { useState, useEffect } from "react";
import "./App.css";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
  // HashRouter,
} from "react-router-dom";
import AOS from "aos";
import PrivateRoute from "./Components/PrivateRoute";

import Home from "./Pages/Home/Home";
import Budget from "./Pages/BudgetList/BudgetList";
import ArchiveBudget from "./Pages/ArchiveBudget/ArchiveBudget";

import { Login } from "./Pages/Login/Login";
import IndexPage from "./Pages/IndexPage/IndexPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./Pages/TermsConditions/TermsConditions";
import Faqs from "./Pages/Faqs/Faqs";
import { history } from './helpers/history';
import ContactUs from "./Pages/ContactUs/ContactUs";
import TagList from "./Pages/Tags/TagList";
import Search from "./Pages/Search/Search";
import AccountList from "./Pages/Accounts/AccountList";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import VerifyAccount from "./Pages/VerifyAccount/VerifyAccount";

function App() {
  // localStorage.setItem("user_text_obj_data1", "1");
  // const [isLoggedIn, setLoginStatus] = useState(
  //   localStorage.getItem("user_text_obj_data1") ? localStorage.getItem("user_text_obj_data1") : null
  // );
  
  const isLoggedIn = localStorage.getItem("user_text_obj_data1") ? true : false; //useSelector((state) => state.userReducer.isLoggedIn);
  useEffect(() => {
    AOS.init();
  }, []);


  return (
    <>
    <Router history={history} basename="/moneytrek">  {/*    */}
      {/* isLoggedIn={isLoggedIn} */}
        <Routes >
          <Route
            path="/web"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />

          <Route path="/" element={<IndexPage />} />
          <Route path="/logout" element={<IndexPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} /> 
          <Route path="/verify-account" element={<VerifyAccount />} /> 
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route
            path="/budgets"
            element={
              <PrivateRoute>
                <Budget />
              </PrivateRoute>
            }
          />
          <Route
            path="/tags"
            element={
              <PrivateRoute>
                <TagList />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <PrivateRoute>
                <AccountList />
              </PrivateRoute>
            }
          />
          <Route
            path="/search"
            element={
              <PrivateRoute>
                <Search />
              </PrivateRoute>
            }
          />

          <Route
            path="/archive"
            element={
              <PrivateRoute>
                <ArchiveBudget />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        </Router>
    </>
  );
}

export default App;
